import {
    Button,
    Dialog,
    DialogTitle,
    List,
    ListItem,
    ListItemText,
  } from "@material-ui/core";
  import * as React from "react";
  import { useDispatch, useSelector } from "react-redux";
  import BaseModal, { BaseModalContent } from "../BaseModal";
  
  const SameVehicleAlertModal = (props) => {
    const { isOpenAllowedSameVehicleAlertModal, setIsOpenAllowedSameVehicleAlertModal,setDefaultsameVehicle, setvehicles } = props;
  
  
    const handleclose = () =>{
      setIsOpenAllowedSameVehicleAlertModal(false)
      setDefaultsameVehicle(false)
      setvehicles([])
    }
  
    return (
      <>
        <BaseModal
                  title="Warning"
                  align="center"
                  open={isOpenAllowedSameVehicleAlertModal}
                  with={500}                
              >
                  <BaseModalContent>
                      {/* <span>You are only allowed to select {allowedNoOfVehcile} {allowedNoOfVehcile>2 ? " vehicles":" vehicle"}</span> */}
                      {/* <span>You cannot order more than one of the same permits for the same vehicle.</span> */}
                      <span>Your permit is already in your cart. Please proceed to complete the purchase or remove it from the cart.</span>
                      <br/><br />
                      <Button style={{float:"right", backgroundColor:"#20419a",color:"white"}} variant="contained" onClick={handleclose}>close</Button>
                  </BaseModalContent>
              </BaseModal>
      </>
    );
  };
  export default SameVehicleAlertModal;
  